import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, breakpoint, fontSize, size } from '@twisto/styles'

export const grayBackgroundVariant = (theme: Theme) => css`
  background: ${theme.palette.background.secondary};
  padding: ${size[48]} ${size[16]} ${size[72]};
`

export const borderedBoxVariant = (theme: Theme) => css`
  border: 1px solid ${theme.palette.neutral[300]};
  padding: ${size[24]};
  border-radius: ${borderRadius.sm};
`

export const multiplicator = (theme: Theme) => css`
  font-size: ${fontSize.xl};
  font-weight: 800;
  color: ${theme.palette.neutral[800]};
  margin: 0 ${size[8]};
`
export const infoRow = css`
  padding: 0;

  ${breakpoint.up('sm')} {
    padding: 0;
  }

  &:not(:last-child) {
    margin-bottom: ${size[12]};
  }
`
